import { Component, TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './features/header/header.component';
import { SidebarService } from './data-access/sidebar.service';
import { SidebarComponentItem } from './sidebar-types';

@Component({
  selector: 'sidebar-content',
  host:{
    'data-tour': 'sidebar-content'
  },
  template: `
    <div class="sidebar-overlay-content" data-tour="sidebar">
      <side-bar-header
        [pages]="sidebarService.pages()"
        (close)="onClose()"
      ></side-bar-header>
      <div class="router-container flex flex-grow flex-col">
        <!-- Route-based content -->
        <router-outlet></router-outlet>

        <!-- Component-based content -->
        <div class="component-container">
          @for (item of getActiveComponentItems(); track item.id) {
            <div class="component-item">
              @if (getContentTemplate(item.id)) {
                <ng-container [ngTemplateOutlet]="getContentTemplate(item.id)"></ng-container>
              } @else {
                <div class="p-4">
                  <h3 class="text-lg font-semibold mb-4">{{ item.title }}</h3>
                  <div class="text-gray-600">
                    <p>No content template found for: {{ item.id }}</p>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  `,
  imports: [
    RouterModule,
    HeaderComponent,
    CommonModule,
  ],
  styles: [`
    .sidebar-overlay-content {
      width: 35dvw;
      height: 100dvh;
      background: white;
      display: flex;
      flex-direction: column;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    }

    .router-container {
      flex: 1;
      overflow-y: auto;
    }

    .component-container {
      flex: 1;
      overflow-y: auto;
      padding: 1rem;
    }

    .component-item {
      width: 100%;
      height: 100%;
    }

    .component-placeholder {
      padding: 2rem;
      text-align: center;
      background: #f8f9fa;
      border: 2px dashed #dee2e6;
      border-radius: 8px;
      margin: 1rem;
    }

    .component-placeholder h3 {
      color: #495057;
      margin-bottom: 1rem;
    }

    .component-placeholder p {
      color: #6c757d;
      margin: 0.5rem 0;
    }
  `],
  standalone: true
})
export class SidebarContentComponent {
  sidebarService: SidebarService;
  getActiveComponentItems: () => SidebarComponentItem[];
  closeSidebar: () => void;
  getContentTemplate: (id: string) => TemplateRef<any> | null;


  onClose() {
    console.log('SidebarContentComponent onClose() called');
    if (this.closeSidebar) {
      console.log('Calling closeSidebar()');
      this.closeSidebar();
    } else {
      console.log('closeSidebar function is not defined');
    }
  }

  // renderContent method removed - using template outlet directly
}
